module.exports = __webpack_public_path__ + "static/media/skill-javascript.18a4357d.png";